/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCommodity.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/commodity";

export class AutogenModelCommodity<RowType extends ModelRow> extends Endpoint<RowType, RowCommodityFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCommodity extends ModelRow<RowCommodityFields> {
	constructor(values?: Partial<RowCommodityFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCommodityFields {
	company_id: string;
	cubic_units: number;
	cubic_units_is_per_piece: string;
	descr: string;
	dunnage_is_per_piece: string;
	dunnage_weight: number;
	fgi_value: number;
	fgi_value_c: string;
	fgi_value_d: Date;
	fgi_value_is_per_piece: string;
	fgi_value_n: number;
	fgi_value_r: number;
	handling_units: number;
	handling_units_is_per_piece: string;
	hazmat: string;
	hazmat_class_code: string;
	hazmat_contact: string;
	hazmat_erg_number: string;
	hazmat_is_residue: string;
	hazmat_number: string;
	hazmat_packing_group: string;
	hazmat_phone: string;
	hazmat_proper_shipname: string;
	hazmat_qty_code: string;
	hazmat_ref_type_code: string;
	hazmat_subclass_code: string;
	height: number;
	id: string;
	intelliset: string;
	is_hazmat: string;
	is_poison: string;
	length: number;
	nmfc_class_code: string;
	nmfc_code: string;
	optiset: string;
	packaging_type_code: string;
	placard_required: string;
	poison_zone: string;
	product_sku: string;
	req_spots: number;
	return_var: number;
	return_var_um: string;
	scan_unit_type: string;
	seats: number;
	seats_is_per_piece: string;
	setpoint_temp: number;
	setpoint_temp_um: string;
	setpoint_var: number;
	setpoint_var_um: string;
	signoff_text: string;
	spots_is_per_piece: string;
	temperature_max: number;
	temperature_max_um: string;
	temperature_min: number;
	temperature_min_um: string;
	training_url: string;
	type_code: string;
	weight: number;
	weight_is_per_piece: string;
	weight_uom_type_code: string;
	width: number;
	product_book_location: string;
}

